const CARD_LIST_LIMIT = 5;
const BRAND_ICON_MAP = {
  'American Express': 'https://shoplineimg.com/assets/footer/card_amex.png',
  'CHINA UNION PAY': 'https://shoplineimg.com/assets/footer/card_unionpay.png',
  Discover: 'https://shoplineimg.com/assets/footer/card_discover.png',
  JCB: 'https://shoplineimg.com/assets/footer/card_jcb.png',
  Mastercard: 'https://shoplineimg.com/assets/footer/card_master.png',
  Visa: 'https://shoplineimg.com/assets/footer/card_visa.png',
  'Diners Club': 'https://shoplineimg.com/assets/footer/card_diners.png',
};

export default {
  CARD_LIST_LIMIT,
  BRAND_ICON_MAP,
};
